/**
 * Created by SammyShan on 2018/11/28.
 */
(function(win) {
    let deviceType = /iphone|ipad|mac|hp-tablet/gi.test(navigator.appVersion)
        ? 1
        : 2
    let env = process.env.VUE_APP_ENV

    win.Global = {
        deviceType: deviceType,
        env: env,
    }
    win.$getHashUrlQuery = function(name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        var r = null
        var tempHashArr = win.location.hash.substr(2).split('?')
        if (tempHashArr.length > 1) {
            r = win.location.hash
                .substr(2)
                .split('?')[1]
                .match(reg)
        }
        if (r !== null) {
            return unescape(r[2])
        }
        return ''
    }

    // 获取参数 history模式
    win.$getUrlQuery = function(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        var r = win.location.search.substr(1).match(reg)
        if (r != null) return unescape(r[2])
        return ''
    }

    // 封装一个方便的定时器
    win.$timer = {
        intervalKeys: [],
        timeoutKeys: [],
        setInterval: function(cb, time) {
            if (typeof time !== 'number') {
                console.log('请在第二个参数传入time')
                return
            }
            if (typeof cb !== 'function') {
                console.log('请在第一个参数传入function')
                return
            }
            var timer = window.setInterval(cb, time)
            this.intervalKeys.push(timer)
            return timer
        },
        setTimeout: function(cb, time) {
            if (typeof time !== 'number') {
                console.log('请在第二个参数传入time')
                return
            }
            if (typeof cb !== 'function') {
                console.log('请在第一个参数传入function')
                return
            }
            var timer = window.setTimeout(cb, time)
            this.timeoutKeys.push(timer)
            return timer
        },
        clearTimeout: function() {
            this.timeoutKeys.forEach(key => {
                window.clearTimeout(key)
            })
            this.timeoutKeys.length = 0
        },
        clearInterval: function() {
            this.intervalKeys.forEach(key => {
                window.clearTimeout(key)
            })
            this.intervalKeys.length = 0
        },
    }

    // 暂存历史记录
    win.$history = {
        saveState: function(openAppId) {
            if (openAppId) {
                let obj = {
                    state: window.history.state,
                    length: window.history.length,
                }
                window.localStorage.setItem(
                    'history_' + openAppId,
                    JSON.stringify(obj)
                )
            }
        },
        getState: function(openAppId) {
            if (openAppId) {
                return JSON.parse(
                    window.localStorage.getItem('history_' + openAppId)
                )
            }
        },
        clearState: function(openAppId) {
            if (openAppId) {
                window.localStorage.removeItem('history_' + openAppId)
            }
        },
    }
    /**
     * [setCookie description]
     * @method setCookie
     * @param {String} name Cookie键名
     * @param {String} value Cookie键值
     * @param {Int} days Cookie有效期天数
     * @param {String} path Cookie有效路径
     * @param {String} domain Cookie有效域
     * @param {Boolean} secure 是否安全Cookie
     */
    win.$setCookie = function(name, value, days, path, domain, secure) {
        var expires
        if (typeof days == 'number') {
            var date = new Date()
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
            expires = date.toGMTString()
        } else if (typeof days == 'string') {
            expires = days
        } else {
            expires = false
        }
        document.cookie =
            name +
            '=' +
            encodeURIComponent(value) +
            (expires ? ';expires=' + expires : '') +
            (path ? ';path=' + path : '') +
            (domain ? ';domain=' + domain : '') +
            (secure ? ';secure' : '')
    }

    /**
     * 获取cookie值
     * @param name
     * @returns {*}
     */
    win.$getCookie = function(name) {
        // if (name === 'token') return '123' // 链接本地服务器时后端跳过token的操作
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
        if ((arr = document.cookie.match(reg))) {
            return decodeURI(arr[2])
        } else {
            return null
        }
    }

    //删除cookie
    win.$clearCookie = function(arr, openAppId) {
        // 必须是数组
        if (typeof arr === 'object') {
            for (let item of arr) {
                win.$setCookie(item, '', -1, '/', '.miaohealth.net', false)
                if (openAppId && item !== 'open_appid') {
                    win.$setCookie(
                        item + '_' + openAppId,
                        '',
                        -1,
                        '/',
                        '.miaohealth.net',
                        false
                    )
                }
            }
        } else {
            win.$setCookie(arr, '', -1, '/', '.miaohealth.net', false)
            if (openAppId) {
                win.$setCookie(
                    arr + '_' + openAppId,
                    '',
                    -1,
                    '/',
                    '.miaohealth.net',
                    false
                )
            }
        }
    }
})(window)
